<div fxFlex="1 1 100" fxLayout="row">
    <div fxFlex="1 1 15%">
        <div fxLayout="column">
            <button mat-raised-button color="primary" (click)="refresh()">
                <span>Refresh</span>
                <mat-icon>refresh</mat-icon>
            </button>
            <p-panelMenu [model]="menuItems">
            </p-panelMenu>
        </div>
    </div>
    <div fxFlex="1 1 85%">
        <div *ngIf="displayType === 'OpeningFile'">
            <div>
                <span>{{errorMessagesByType[selectedQueryName]}}</span>
            </div>
            <div>
                <h3 class="center">{{selectedQueryName}}</h3>
            </div>
            <div>
                <p-table #dt [columns]="selectedColumns" [value]="getSelectedOpeningTableData()" [paginator]="true"
                    [rows]="50" [resizableColumns]="true" [loading]="loading" [exportFilename]="selectedQueryName + '.csv'">
                    <ng-template pTemplate="caption">
                        <div class="p-helper-clearfix">
                            <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Export All Data"
                                (click)="dt.exportCSV()"  style="float:left"></button>
                        </div>
                        <div style="text-align: right">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="50" placeholder="Global Filter"
                                (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                        </div>
                        <div style="text-align:left">
                            <p-multiSelect [options]="getSelectedOpeningTableColumns()" [(ngModel)]="selectedColumns"
                                optionLabel="header" selectedItemsLabel="{0} columns selected"
                                [style]="{minWidth: '200px'}" defaultLabel="Choose Columns" scrollHeight="400px">
                            </p-multiSelect>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <col *ngFor="let col of columns" style="width:150px">
                        </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns">
                                {{col.header}}
                            </th>
                        </tr>
                        <tr>
                            <th *ngFor="let col of columns" [ngSwitch]="col.field">
                                <input pInputText type="text"
                                    (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            <td *ngFor="let col of columns">
                                {{rowData[col.field]}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <!-- 


                <input #gb type="text" placeholder="Global search">
                <p-dataTable [value]="getSelectedOpeningTableData()" scrollable="true" [rows]="50" [paginator]="true"
                    paginatorPosition="top" selectionMode="single" [globalFilter]="gb">
                    <p-column *ngFor="let col of getSelectedOpeningTableColumns()" [filter]="true" [sortable]="true"
                        [field]="col.field" [header]="col.header"></p-column>
                </p-dataTable> -->
            </div>
        </div>
        <div [fxHide]="displayType !== 'HealthCheck'">
            <div>
                <div *ngIf="currentHealthCheckResults">
                    <span class="liquitics-box">Transaction Flows for Day:
                        {{currentHealthCheckResults.healthCheckResponse.ladderFlowCount}}</span>
                    <span class="liquitics-box">Account Flows for Day:
                        {{currentHealthCheckResults.healthCheckResponse.accountFlowCount}}</span>
                    <span class="liquitics-box">Redshift Cluster Status:
                        {{currentHealthCheckResults.healthCheckResponse.redshiftClusterStatus}}</span>
                </div>
                <div #chartwrapper class="chartwrapper liquitics-box">
                    <div id="throughputchartdiv" class="chartdiv"></div>
                </div>
                <div fxLayout="row">
                    <div *ngIf="currentHealthCheckResults" class="liquitics-box">
                        <div
                            *ngFor="let transactionS3Status of currentHealthCheckResults.transactionS3Statuses; let i = index">
                            <span>{{transactionS3Status.hour}}</span>
                            <span *ngIf="yesterdaysHealthCheckResults.transactionS3Statuses[i].exists"
                                class="fa fa-check"></span>
                            <span *ngIf="!yesterdaysHealthCheckResults.transactionS3Statuses[i].exists"
                                class="fa fa-times"></span>
                            <span *ngIf="transactionS3Status.exists" class="fa fa-check"></span>
                            <span *ngIf="!transactionS3Status.exists" class="fa fa-times"></span>
                        </div>
                    </div>
                    <div *ngIf="currentHealthCheckResults" class="liquitics-box">
                        <div
                            *ngFor="let hourlyTransactionCount of currentHealthCheckResults.healthCheckResponse.hourlyTransactionCounts; let i = index">
                            <span>{{yesterdaysHealthCheckResults.healthCheckResponse.hourlyTransactionCounts[i].count}}</span>
                            <span>{{currentHealthCheckResults.healthCheckResponse.hourlyTransactionCounts[i].count}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [fxHide]="displayType !== 'WarehouseProgress'">
            <p-table *ngIf="currentHealthCheckResults && currentHealthCheckResults.healthCheckResponse"
                [value]="currentHealthCheckResults.healthCheckResponse.eodTaskProgress">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 10em">Category</th>
                        <th style="width: 3em">Failed</th>
                        <th style="width: 3em">Running</th>
                        <th style="width: 3em">Success</th>
                        <th style="width: 3em">Pending</th>
                        <th style="width: 3em">Timeout</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [ngClass]="'warehouse-progress-row-status-' + rowData.status">
                        <td>{{rowData.category}}</td>
                        <td class="text-center"><span>{{rowData.failCount}}/{{rowData.count}}</span> <span>({{rowData.failCount/rowData.count
                            | percent}})</span></td>
                        <td class="text-center"><span>{{rowData.runningCount}}/{{rowData.count}}</span> <span>({{rowData.runningCount/rowData.count
                            | percent}})</span></td>
                        <td class="text-center"><span>{{rowData.successCount}}/{{rowData.count}}</span> <span>({{rowData.successCount/rowData.count
                            | percent}})</span></td>
                        <td class="text-center"><span>{{rowData.pendingCount}}/{{rowData.count}}</span> <span>({{rowData.pendingCount/rowData.count
                            | percent}})</span></td>
                        <td class="text-center"><span>{{rowData.timeoutCount}}/{{rowData.count}}</span> <span>({{rowData.timeoutCount/rowData.count
                            | percent}})</span></td>
                    </tr>
                </ng-template>
            </p-table>
            <p-table #detailsTable [columns]="eodDetailsCols"
                *ngIf="currentHealthCheckResults && currentHealthCheckResults.healthCheckResponse"
                [value]="currentHealthCheckResults.healthCheckResponse.eodTaskProgressDetails">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [style.width]="col.width">{{col.header}}</th>
                    </tr>
                    <tr>
                        <th *ngFor="let col of columns" [style.width]="col.width" [ngSwitch]="col.field">
                            <p-multiSelect *ngSwitchCase="'status'" [options]="eodTaskStatuses" defaultLabel="Statuses"
                                (onChange)="detailsTable.filter($event.value, col.field, 'in')"></p-multiSelect>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [ngClass]="'warehouse-progress-row-status-' + rowData.status">
                        <td>{{rowData.task_order}}</td>
                        <td>{{rowData.task_name}}</td>
                        <td>{{rowData.status}}</td>
                        <td>{{rowData.start_datetime}}</td>
                        <td>{{rowData.finish_datetime}}</td>
                        <td>{{rowData.duration}}</td>
                        <td>{{rowData.message}}</td>
                        <td>{{rowData.failure_count}}</td>
                        <!-- <td>{{rowData.task_category}}</td> -->
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div [fxHide]="displayType !== 'SweepInstructions'">
            <p-table [value]="sweepInstructions" scrollable="true" [rows]="50" [paginator]="true"
                paginatorPosition="top" selectionMode="single" [loading]="loading">
                <ng-template pTemplate="header">
                    <tr>
                        <th>From Account</th>
                        <th>To Account</th>
                        <th>Currency</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>User Name</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{row.fromAccount}}</td>
                        <td>{{row.toAccount}}</td>
                        <td>{{row.currency}}</td>
                        <td>{{row.amount}}</td>
                        <td>{{row.settleDate}}</td>
                        <td>{{row.userName}}</td>
                    </tr>
                </ng-template>

                <!-- <p-column field="fromAccount" header="From Account"></p-column>
                <p-column field="toAccount" header="To Account"></p-column>
                <p-column field="currency" header="Currency"></p-column>
                <p-column field="amount" header="Amount"></p-column>
                <p-column field="settleDate" header="Date"></p-column> -->
<!--Already commented-->
                <!-- <p-column field="reason" header="Reason"></p-column> -->
                <!-- <p-column field="userName" header="User Name"></p-column> -->
            </p-table>
        </div>
    </div>
</div>

<!-- <p-tabView *ngIf="filePrefixes" orientation="left">
    <p-tabPanel [header]="getTitleName(filePrefix)" *ngFor="let filePrefix of filePrefixes">
        <div *ngIf="columnAndTableDataByType[filePrefix]">
            <input #gb type="text" placeholder="Global search">
            <p-dataTable [value]="columnAndTableDataByType[filePrefix]['tableData']" scrollable="true" [rows]="50" [paginator]="true"
                paginatorPosition="top" selectionMode="single" [globalFilter]="gb">
                <p-column *ngFor="let col of columnAndTableDataByType[filePrefix]['columns']" [filter]="true" [sortable]="true" [field]="col.field"
                    [header]="col.header"></p-column>
            </p-dataTable>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Health Check">
        <button mat-icon-button (click)="refreshHealthCheck()">
            <mat-icon>refresh</mat-icon>
        </button>
        <div>
            <div *ngIf="currentHealthCheckResults">
                <span class="liquitics-box">Transaction Flows for Day: {{currentHealthCheckResults.healthCheckResponse.ladderFlowCount}}</span>
                <span class="liquitics-box">Account Flows for Day: {{currentHealthCheckResults.healthCheckResponse.accountFlowCount}}</span>
                <span class="liquitics-box">Redshift Cluster Status: {{currentHealthCheckResults.healthCheckResponse.redshiftClusterStatus}}</span>
            </div>
            <div #chartwrapper class="chartwrapper liquitics-box">
                <div id="throughputchartdiv" class="chartdiv"></div>
            </div>
            <div fxLayout="row">
                <div *ngIf="currentHealthCheckResults" class="liquitics-box">
                    <div *ngFor="let transactionS3Status of currentHealthCheckResults.transactionS3Statuses; let i = index">
                        <span>{{transactionS3Status.hour}}</span>
                        <span *ngIf="yesterdaysHealthCheckResults.transactionS3Statuses[i].exists" class="fa fa-check"></span>
                        <span *ngIf="!yesterdaysHealthCheckResults.transactionS3Statuses[i].exists" class="fa fa-times"></span>
                        <span *ngIf="transactionS3Status.exists" class="fa fa-check"></span>
                        <span *ngIf="!transactionS3Status.exists" class="fa fa-times"></span>
                    </div>
                </div>
                <div *ngIf="currentHealthCheckResults" class="liquitics-box">
                    <div *ngFor="let hourlyTransactionCount of currentHealthCheckResults.healthCheckResponse.hourlyTransactionCounts; let i = index">
                        <span>{{yesterdaysHealthCheckResults.healthCheckResponse.hourlyTransactionCounts[i].count}}</span>
                        <span>{{currentHealthCheckResults.healthCheckResponse.hourlyTransactionCounts[i].count}}</span>
                    </div>
                </div>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Warehousing Progress">
        <button mat-icon-button (click)="refreshHealthCheck()">
            <mat-icon>refresh</mat-icon>
        </button>

        <p-table *ngIf="currentHealthCheckResults.healthCheckResponse" [value]="currentHealthCheckResults.healthCheckResponse.eodTaskProgressDetails">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width: 1em">Order</th>
                    <th style="width: 15em">Task</th>
                    <th style="width: 4em">Status</th>
                    <th style="width: 5em">Start</th>
                    <th style="width: 5em">End</th>
                    <th style="width: 10em">Message</th>
                    <th style="width: 5em">Category</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [ngClass]="'warehouse-progress-row-status-' + rowData.status">
                    <td>{{rowData.task_order}}</td>
                    <td>{{rowData.task_name}}</td>
                    <td>{{rowData.status}}</td>
                    <td>{{rowData.start_datetime}}</td>
                    <td>{{rowData.finish_datetime}}</td>
                    <td>{{rowData.message}}</td>
                    <td>{{rowData.task_category}}</td>
                </tr>
            </ng-template>
        </p-table>


    </p-tabPanel>
    <p-tabPanel header="Sweep Instructions">
        <button mat-icon-button (click)="refreshSweepInstructions()">
            <mat-icon>refresh</mat-icon>
        </button>
        <p-dataTable [value]="sweepInstructions" scrollable="true" [rows]="50" [paginator]="true" paginatorPosition="top" selectionMode="single"
            [globalFilter]="gb">
            <p-column field="fromAccount" header="From Account"></p-column>
            <p-column field="toAccount" header="To Account"></p-column>
            <p-column field="currency" header="Currency"></p-column>
            <p-column field="amount" header="Amount"></p-column>
            <p-column field="settleDate" header="Date"></p-column>
            <p-column field="reason" header="Reason"></p-column>
            <p-column field="userName" header="User Name"></p-column>
        </p-dataTable>
    </p-tabPanel>
</p-tabView> -->